import React, { Component } from 'react';
import {connect} from 'react-redux';
import { fetchAlldemoCategories} from '../../actions/demographics';
import { emptyResponseUserDemographicsData } from '../../actions/country'
import UserDemographicsCategoriesList from '../../components/country/userDemographics';


class UserDemographicsCategories extends Component {
  constructor(props){
    super(props)
    this.state={

    };
    
    this.showDataDemographics = this.showDataDemographics.bind(this);
  }

  
  componentWillMount() {
    let token=sessionStorage.getItem("adminToken");
    this.props.dispatch(fetchAlldemoCategories(token));
  }

  showDataDemographics(catID, userID){
    this.props.dispatch(emptyResponseUserDemographicsData());
   this.props.history.push("/UserDemographicsDetails/&catId="+catID+"&UID="+userID);
  }

  render(){
    let showDemographicsCategoriesView = <UserDemographicsCategoriesList
        demoGraphicsCategoriesListSuccess = {this.props.demoGraphicsCategoriesListSuccess}
        demoGraphicsCategoriesList = {this.props.demoGraphicsCategoriesList}
        showDataDemographics = {this.showDataDemographics}
       
    />
      
    return (
        <div> 
             {showDemographicsCategoriesView}
        </div>
    );
  }
}

const  mapStateToProps =(state) =>{
  return {
    demoGraphicsCategoriesListSuccess : state.demographics.demoGraphicsCategoriesListSuccess,
    demoGraphicsCategoriesList : state.demographics.demoGraphicsCategoriesList
  }
}

export default connect(mapStateToProps)(UserDemographicsCategories);



// WEBPACK FOOTER //
// ./src/pages/country/userDemographic.js